import React, { useState } from "react";
import dryChilliImage from "../resourcess/Products/Red chilies PM.png";
import turmericImage from "../resourcess/Products/Turmeric powder and roots display.png";
import chilliPowderImage from "../resourcess/Products/Specialty Chilli Powder.png";
import garlicImage from "../resourcess/Products/garlic.png";
import onionImage from "../resourcess/Products/onion.png";
import deOnionImage from "../resourcess/Products/de onion.png";

const slides = [
  {
    title: "Dry Red Chilli",
    lines: [
      "Premium Indian dry red chillies known for their high pungency, vibrant color, and rich aroma. Carefully sourced from top farms and hygienically processed to meet export standards and bulk supply requirements.",
    ],
    highlight: "High Pungency , Vibrant Color",
    highlightColor: "#e11d23",
    cardBackgroundColor: "linear-gradient(135deg, #ffe6e6, #ffd9d9)",
    image: dryChilliImage,
    alt: "Premium dry red chillies in burlap sack",
  },
  {
    title: "Red Onion",
    lines: [
      "Fresh export-quality onions",
      "Firm texture and uniform size",
      "Suitable for bulk supply and export"
    ],
    highlight: "Fresh Quality • Bulk Supply",
    highlightColor: "#924960",
    cardBackgroundColor: "linear-gradient(135deg, #f5e6eb, #ead5dc)",
    image: onionImage,
    alt: "Whole red onions on a rustic surface",
  },
  {
    title: "Red Chilli Powder",
    lines: [
      "Teja – high heat ",
      "Byadgi – deep red colour ",
      "Sannam – balanced flavour."
    ],
    highlight: "High colour, premium quality",
    highlightColor: "#e11d23",
    cardBackgroundColor: "linear-gradient(135deg, #ffe6e6, #ffd9d9)",
    image: chilliPowderImage,
    alt: "Speciality chilli powder with dry chillies",
  },
  {
    title: "Dehydrated Onion",
    lines: [
      "Processed onion with extended shelf life .",
      "Retains natural flavor and aroma",
      "Ideal for food processing and industrial use"
    ],
    highlight: "Long Shelf Life • Natural Flavour",
    highlightColor: "#b45309",
    cardBackgroundColor: "linear-gradient(135deg, #fef5e7, #fce8cc)",
    image: deOnionImage,
    alt: "Dehydrated onion flakes in a bowl",
  },
  {
    title: "Turmeric",
    lines: [
      "Premium high-curcumin turmeric known for its bright color, natural purity, and strong aroma. Carefully sourced and processed to meet export standards across food and pharmaceutical industries.",
    ],
    highlight: "High Curcumin • Natural Purity",
    highlightColor: "#d97706",
    cardBackgroundColor: "linear-gradient(135deg, #fef3e2, #fce7c3)",
    image: turmericImage,
    alt: "Turmeric roots and turmeric powder in a bowl",
  },
  {
    title: "Dehydrated Garlic",
    lines: [
      "High-quality dehydrated garlic powder",
      "Strong aroma and consistent texture",
      "Suitable for food and industrial use"
    ],
    highlight: "Strong Aroma • Food-Grade Quality",
    highlightColor: "#b45309",
    cardBackgroundColor: "linear-gradient(135deg, #fef5e7, #fce8cc)",
    image: garlicImage,
    alt: "Garlic powder in a bowl with garlic bulbs",
  },
];

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const current = slides[activeIndex];

  return (
    <section id="products" className="section products-section">
      <div className="section-inner">
        <h2 className="section-heading">Products</h2>
        <div className="products-card" style={{ background: current.cardBackgroundColor }}>
          <div className="products-card-text">
            <h3 className="products-title" style={{ color: current.highlightColor }}>
              {current.title}
            </h3>
            {current.lines.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
            <p
              className="products-highlight"
              style={
                current.highlightColor
                  ? { color: current.highlightColor }
                  : undefined
              }
            >
              {current.highlight}
            </p>
            <button 
              className="btn-primary products-btn"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Get Quote
            </button>
          </div>
          <div className="products-card-image">
            <img src={current.image} alt={current.alt} />
          </div>
        </div>
        <div className="products-nav">
          <button
            type="button"
            className="products-arrow products-arrow-left"
            onClick={handlePrev}
            aria-label="Previous product"
          >
            ‹
          </button>
          <div className="products-dots" aria-hidden="true">
            {slides.map((_, index) => (
              <span
                key={index}
                className={index === activeIndex ? "dot dot-active" : "dot"}
              />
            ))}
          </div>
          <button
            type="button"
            className="products-arrow products-arrow-right"
            onClick={handleNext}
            aria-label="Next product"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
